import { ImportCase } from './types-store';
import { ImportFormData } from 'app/area/import/types';

export const ACTION = {
  REQUEST_IMPORT_LIST: 'IMPORT:REQUEST_IMPORT_LIST',
  RECEIVE_IMPORT_LIST: 'IMPORT:RECEIVE_IMPORT_LIST',
  FAIL_IMPORT_LIST: 'IMPORT:FAIL_IMPORT_LIST',

  REQUEST_MORE_IMPORT_LIST_ITEMS: 'IMPORT:REQUEST_MORE_IMPORT_LIST_ITEMS',
  RECEIVE_MORE_IMPORT_LIST_ITEMS: 'IMPORT:RECEIVE_MORE_IMPORT_LIST_ITEMS',
  FAIL_MORE_IMPORT_LIST_ITEMS: 'IMPORT:FAIL_MORE_IMPORT_LIST_ITEMS',

  REQUEST_LOAD_EDIT_IMPORT: 'IMPORT:REQUEST_LOAD_EDIT_IMPORT',
  RECEIVE_LOAD_EDIT_IMPORT: 'IMPORT:RECEIVE_LOAD_EDIT_IMPORT',
  FAIL_LOAD_EDIT_IMPORT: 'IMPORT:FAIL_LOAD_EDIT_IMPORT',
  CLEAR_EDIT_IMPORT: 'IMPORT:CLEAR_EDIT_IMPORT',

  REQUEST_LOAD_IMPORT_DETAILS: 'IMPORT:REQUEST_LOAD_IMPORT_DETAILS',
  RECEIVE_LOAD_IMPORT_DETAILS: 'IMPORT:RECEIVE_LOAD_IMPORT_DETAILS',
  FAIL_LOAD_IMPORT_DETAILS: 'IMPORT:FAIL_LOAD_IMPORT_DETAILS',
  CLEAR_IMPORT_DETAILS: 'IMPORT:CLEAR_IMPORT_DETAILS',

  REQUEST_ADD_IMPORT: 'IMPORT:REQUEST_ADD_IMPORT',
  RECEIVE_ADD_IMPORT: 'IMPORT:RECEIVE_ADD_IMPORT',
  FAIL_ADD_IMPORT: 'IMPORT:FAIL_ADD_IMPORT',

  REQUEST_UPDATE_IMPORT: 'IMPORT:REQUEST_UPDATE_IMPORT',
  RECEIVE_UPDATE_IMPORT: 'IMPORT:RECEIVE_UPDATE_IMPORT',
  FAIL_UPDATE_IMPORT: 'IMPORT:FAIL_UPDATE_IMPORT',

  REQUEST_RETRY_IMPORT: 'IMPORT:REQUEST_RETRY_IMPORT',
  RECEIVE_RETRY_IMPORT: 'IMPORT:RECEIVE_RETRY_IMPORT',
  FAIL_RETRY_IMPORT: 'IMPORT:FAIL_RETRY_IMPORT',

  REQUEST_DELETE_IMPORT: 'IMPORT:REQUEST_DELETE_IMPORT',
  RECEIVE_DELETE_IMPORT: 'IMPORT:RECEIVE_DELETE_IMPORT',
  FAIL_DELETE_IMPORT: 'IMPORT:FAIL_DELETE_IMPORT',

  CLEAR_IMPORT_CASE: 'IMPORT:CLEAR_IMPORT_CASE'
};

export class RequestImportList {
  public type: string = ACTION.REQUEST_IMPORT_LIST;
}

export class ReceiveImportList {
  public type: string = ACTION.RECEIVE_IMPORT_LIST;
  public importList: ImportCase[];

  constructor(importList: ImportCase[]) {
    this.importList = importList;
  }
}

export class FailImportList {
  public type: string = ACTION.FAIL_IMPORT_LIST;
}

export class RequestMoreImportListItems {
  public type: string = ACTION.REQUEST_MORE_IMPORT_LIST_ITEMS;
}

export class ReceiveMoreImportListItems {
  public type: string = ACTION.RECEIVE_MORE_IMPORT_LIST_ITEMS;

  constructor(public importList: ImportCase[], public reachedEndOfList: boolean) {}
}

export class FailMoreImportListItems {
  public type: string = ACTION.FAIL_MORE_IMPORT_LIST_ITEMS;
}

export class RequestLoadEditImport {
  public type: string = ACTION.REQUEST_LOAD_EDIT_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ReceiveLoadEditImport {
  public type: string = ACTION.RECEIVE_LOAD_EDIT_IMPORT;
  public importCase: any;

  constructor(importCase: ImportCase) {
    this.importCase = importCase;
  }
}

export class FailLoadEditImport {
  public type: string = ACTION.FAIL_LOAD_EDIT_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class RequestAddImport {
  public type: string = ACTION.REQUEST_ADD_IMPORT;
}

export class ReceiveAddImport {
  public type: string = ACTION.RECEIVE_ADD_IMPORT;
}

export class FailAddImport {
  public type: string = ACTION.FAIL_ADD_IMPORT;
}

export class RequestUpdateImport {
  public type: string = ACTION.REQUEST_UPDATE_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ReceiveUpdateImport {
  public type: string = ACTION.RECEIVE_UPDATE_IMPORT;
  public importCaseId: number;
  public serializeData: ImportFormData;

  constructor(importCaseId: number, serializeData: ImportFormData) {
    this.importCaseId = importCaseId;
    this.serializeData = serializeData;
  }
}

export class FailUpdateImport {
  public type: string = ACTION.FAIL_UPDATE_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ClearEditImport {
  public type: string = ACTION.CLEAR_EDIT_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class RequestRetryImport {
  public type: string = ACTION.REQUEST_RETRY_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ReceiveRetryImport {
  public type: string = ACTION.RECEIVE_RETRY_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class FailRetryImport {
  public type: string = ACTION.FAIL_RETRY_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class RequestDeleteImport {
  public type: string = ACTION.REQUEST_DELETE_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ReceiveDeleteImport {
  public type: string = ACTION.RECEIVE_DELETE_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class FailDeleteImport {
  public type: string = ACTION.FAIL_DELETE_IMPORT;
  public importCaseId: number;

  constructor(importCaseId: number) {
    this.importCaseId = importCaseId;
  }
}

export class ClearImportCase {
  public type: string = ACTION.CLEAR_IMPORT_CASE;
}

export class RequestLoadImportDetails {
  public type: string = ACTION.REQUEST_LOAD_IMPORT_DETAILS;
  
  constructor(public importCaseId: number) {}
}

export class ReceiveLoadImportDetails {
  public type: string = ACTION.RECEIVE_LOAD_IMPORT_DETAILS;

  constructor(public importCase: ImportCase) {}
}

export class FailLoadImportDetails {
  public type: string = ACTION.FAIL_LOAD_IMPORT_DETAILS;
  
  constructor(public importCaseId: number) {}
}

export class ClearImportDetails {
  public type: string = ACTION.CLEAR_IMPORT_CASE;
}
